import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { MembershipState, PMSEmailTemplateState } from './store';

import { ApiMembershipService } from './services/api-membership.service';
import { ApiPMSEmailTemplateService } from './services/api-pms-email-template.service';

@NgModule({
  imports: [
    NgxsModule.forFeature([ MembershipState, PMSEmailTemplateState ])
  ],
  providers: [
    ApiMembershipService,
    ApiPMSEmailTemplateService
  ]
})
export class MembershipDataAccessForMigrationModule {

  static forRoot(environment: Environment): ModuleWithProviders<MembershipDataAccessForMigrationModule> {
    return {
      ngModule: MembershipDataAccessForMigrationModule,
      providers: [{ provide: APP_ENVIRONMENT, useValue: environment }]
    };
  }

}

